/**
 * Pause execution for a given amount of milliseconds.
 */
export const sleep = (ms) => {
    return new Promise(resolve => setTimeout(resolve, ms));
};